import React from 'react';

const CompletionScreen = () => {
  return <div>PaymentScreen</div>;
};

export default CompletionScreen;
